import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';
import Link from 'next/link';

export const RepositoryNavTabs = styled.div`
  width: 100%;
  display: flex;
  align-items: center !important;
  gap: 30px;
  padding-bottom: 0px;
  /* overflow-x: auto; */
`;

export const LinkTab = styled(Link)<{ $active?: boolean; disabled?: boolean; $hideMobile?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 0 10px 0;
  border-bottom: ${(props) => (props.$active ? `1px solid ${colors.primary.black}` : 'none')};
  margin-bottom: -1px;
  color: ${(props) => (props.disabled ? colors.semantic.disabled : colors.primary.black)};
  white-space: nowrap;

  @media (max-width: ${breakPoints.mobile}) {
    display: ${(props) => (props.$hideMobile ? 'none' : 'flex')};
  }
`;
